import http from '@/utils/http';
import i18n from '@/main';

const URL_BASE = '/pessoa';
const URL_REPRESENTANTE = '/representantes';

export default {
    buscarPessoa(codigoTipoPessoa) {
        return http.get({
            url: URL_BASE + `/${codigoTipoPessoa}`,
            lockScreen: false
        });
    },

    buscaPerfilpessoa() {
        return http.get({
            url: URL_BASE + `/perfil`,
            lockScreen: false
        });
    },

    buscaPessoabunge() {
        return http.get({
            url: URL_BASE + `/pessoaBunge`,
            lockScreen: false
        });
    },
    exportarPessoas(simplificado) {
        return http.get({
            url: URL_REPRESENTANTE + `/exportar/${simplificado}`,
            responseType: 'blob',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
        });
    }
};
